<template>
  <div>
    <div>
      <div v-if="!first_time_logged_in">
        <div class="page-title-cont">
          <h1 class="wp-heading-inline">WPCal.io - {{ T__("Settings") }}</h1>
          <AdminHeaderRight />
        </div>
        <SettingsMenu />
      </div>
      <div v-else>
        <div class="page-title-cont">
          <AdminHeaderRight />
        </div>
      </div>
      <div class="col-cont">
        <div class="col" style="margin: 100px auto 0;">
          <div v-if="show_form == 'login'">
            <!--Login Form -->
            <div style="font-size: 20px; text-align: center; padding: 20px;">
              {{ T__("Login to your WPCal.io account") }}
            </div>
            <div class="validation_errors_cont"></div>
            <div class="form">
              <div
                style="border: 1px dashed #81e846; padding: 10px; border-radius: 5px; background-color: rgba(129, 232, 70, 0.2); margin-bottom: 10px;"
                v-if="form_signup_success"
                v-html="
                  Tsprintf(
                    /* translators: 1: html-tag-open 2: html-tag-close */
                    T__(
                      'Your account has been created successfully. Please login now using the %1$spassword sent to your email%2$s.'
                    ),
                    '<span style=&quot;border-bottom: 1px dashed;&quot;>',
                    '</span>'
                  )
                "
              ></div>
              <div
                style="background-color: rgb(228, 233, 245);border: 1px dashed rgb(86, 123, 243);padding: 10px;border-radius: 5px;margin-bottom: 20px;text-align: center;"
                v-if="show_login_with_other_account_txt"
              >
                Login below with another account<br />
              </div>
              <form-row :validator="$v.form_login.email">
                <label
                  for="form_login_email"
                  style="text-transform: uppercase; font-size: 12px;"
                  >{{ T__("Email address") }}</label
                >
                <input
                  id="form_login_email"
                  type="text"
                  name="email"
                  tabindex="1"
                  v-model="form_login.email"
                  @blur="$v.form_login.email.$touch()"
                  ref="form_login_email"
                />
              </form-row>
              <form-row :validator="$v.form_login.password">
                <label
                  for="form_login_password"
                  style="text-transform: uppercase; font-size: 12px;"
                >
                  {{ T__("Password") }}
                  <em style="margin-top:0;">
                    <a
                      style="text-transform: capitalize;"
                      :href="$store.getters.get_wpcal_site_urls.lost_pass_url"
                      target="_blank"
                      >{{ T__("Forgot password?") }}</a
                    >
                  </em>
                </label>
                <input
                  id="form_login_password"
                  type="password"
                  tabindex="2"
                  v-model="form_login.password"
                  @blur="$v.form_login.password.$touch()"
                />
              </form-row>
              <div class="wpc-form-row">
                <button
                  type="button"
                  class="wpc-btn primary lg"
                  tabindex="3"
                  @click="
                    form_login_submit();
                    form_signup_success = false;
                  "
                  :disabled="!login_btn_is_enabled"
                >
                  {{ login_btn_txt }}
                </button>
              </div>
            </div>
            <div
              style="text-align:center; font-size:14px;"
              class="wpc-form-row"
            >
              {{ T__("Don't have an account yet?") }}
              <a style="font-size:14px;" @click="show_signup_form">{{
                T__("Create your account now")
              }}</a
              >.
            </div>
          </div>
          <!-- ====================================== -->
          <div v-if="show_form == 'signup'">
            <!--Signup Form -->
            <div style="font-size: 20px; text-align: center; padding: 20px;">
              {{ T__("Create your WPCal.io account") }}
            </div>
            <div
              style="background-color: #E4E9F5; border: 1px dashed #567bf3; padding: 10px 10px 0px 10px; border-radius: 5px; margin-bottom: 20px;"
            >
              {{ T__("You need to create an account for -") }}
              <br />
              <ul>
                <li style="list-style: disc; margin-left: 20px;">
                  {{
                    T_x(
                      "timely notification emails to you and your invitees.",
                      "You need to create an account for"
                    )
                  }}
                </li>
                <li style="list-style: disc; margin-left: 20px;">
                  {{
                    T_x(
                      "1-click connect to apps like Zoom, Google Meet etc.",
                      "You need to create an account for"
                    )
                  }}
                </li>
                <li
                  style="list-style: disc; margin-left: 20px; margin-bottom: 0;"
                >
                  {{
                    T_x(
                      "syncing calendar event changes to handle conflicts.",
                      "You need to create an account for"
                    )
                  }}
                </li>
              </ul>
            </div>
            <div class="validation_errors_cont"></div>
            <div class="form">
              <form-row :validator="$v.form_signup.email">
                <label
                  for="form_singup_email"
                  style="text-transform: uppercase; font-size: 12px; font-family: 'RubikMed';"
                  >{{ T__("Enter your email") }}</label
                >
                <div style="margin-bottom: 5px;">
                  {{
                    T__(
                      " This email will be used only for licensing purposes. For bookings, your WP admin user email will be used."
                    )
                  }}
                </div>
                <input
                  id="form_singup_email"
                  type="text"
                  name="email"
                  v-model="form_signup.email"
                  @blur="$v.form_signup.email.$touch()"
                  @focus="signup_password_note_shown_once = true"
                />
                <span
                  v-show="show_signup_password_note"
                  style="font-size: 12px;font-style: italic;padding: 5px;background-color: #fff200;display: inline-block;margin-top: 5px;"
                  >{{
                    T__(
                      "A secure password will be sent to this email for you to login next time."
                    )
                  }}</span
                >
              </form-row>
              <div
                style="padding-bottom: 10px; text-align: center; font-size: 11px;"
                v-html="
                  Tsprintf(
                    /* translators: 1: html-tag-open 2: html-tag-close */
                    T__(
                      'By clicking on the Create my Account now button below, you agree that you have read and accept the %1$sTerms of Use%2$s'
                    ),
                    '<a style=&quot;font-size: 11px;&quot; href=&quot;https://wpcal.io/terms-of-use/&quot; target=&quot;_blank&quot;>',
                    '</a>.'
                  )
                "
              ></div>
              <div class="wpc-form-row">
                <button
                  type="button"
                  class="wpc-btn primary lg"
                  @click="form_signup_and_login_submit"
                  :disabled="!signup_btn_is_enabled"
                >
                  {{ signup_btn_txt }}
                </button>
              </div>
              <div
                class="wpc-form-row"
                style="text-align:center; font-size:14px;"
              >
                {{ T__("Already have an account?") }}
                <a style=" font-size:14px;" @click="show_login_form(false)">{{
                  T__("Login now")
                }}</a
                >.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ====================================== -->
    <modal
      name="stronger_together_plan_modal"
      :width="'700px'"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      @before-close="stronger_together_plan_modal_before_close"
      style="z-index:9999;"
    >
      <div class="covid-consent-cont">
        <PricingStrongerTogether />
        <div class="consent-action">
          <div style="font-weight:500;">COVID-19 CONSENT</div>
          <label class="consent-agreement">
            <input
              type="checkbox"
              v-model="stronger_together_plan_details.consent"
            />I understand that the <strong>Stronger, Together!</strong> plan
            will be available only during the COVID-19 crisis after which I can
            either continue using the free features or need to subscribe to a
            paid plan to continue using premium features.
          </label>
          <div style="text-align: center;">
            We’ll email you at
            <strong>{{ $store.getters.get_license_info.email }}</strong
            >, 30 days in advance before <br />removing the
            <strong>Stronger, Together!</strong> plan.
          </div>
        </div>
        <div style="text-align:right;margin-top:30px;">
          <button
            :disabled="!stronger_together_plan_details.consent"
            @click="handle_stronger_together_plan_modal_button"
          >
            I understand, Continue &rarr;
          </button>
        </div>
      </div>
    </modal>
    <a @click="show_stronger_together_plan_modal" style="display:none;"
      >___ Lorem Ipsum (Show Stronger, Together!)</a
    >
  </div>
</template>

<script>
import SettingsMenu from "@/components/admin/SettingsMenu.vue";
import PricingStrongerTogether from "@/components/admin/PricingStrongerTogether.vue";

import { required, email } from "vuelidate/lib/validators";

import axios from "axios";

export default {
  components: {
    SettingsMenu,
    PricingStrongerTogether
  },
  props: {
    attempt_to_change_account: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      document_title: this.T__("Plan ‹ Settings"),
      form_login: {
        email: "",
        password: ""
      },
      form_signup: {
        email: ""
      },
      show_form: "login",
      form_signup_success: false,
      stronger_together_plan_details: {
        consent: false,
        i_understand_clicked: false
      },
      first_time_logged_in: false,
      login_btn_is_enabled: true,
      signup_btn_is_enabled: true,
      signup_password_note_shown_once: false,
      show_login_with_other_account_txt: false
    };
  },
  validations: {
    form_login: {
      email: { required, email },
      password: { required }
    },
    form_signup: {
      email: { required, email }
    }
  },
  computed: {
    login_btn_txt() {
      return this.login_btn_is_enabled
        ? this.T__("Login to my account")
        : this.T__("Logging you in...");
    }, //
    signup_btn_txt() {
      return this.signup_btn_is_enabled
        ? this.T__("Create my account & Login")
        : this.T__("Creating your account & logging in...");
      // return this.signup_btn_is_enabled
      //   ? this.T__("Create my Account now")
      //   : this.T__("Creating your account...");
    },
    show_signup_password_note() {
      if (this.signup_password_note_shown_once) {
        return true;
      }
      let is_show = this.form_signup.email.length > 0;
      return is_show;
    }
  },
  methods: {
    on_login_success(response_license_info) {
      if (this.first_time_logged_in === true) {
        this.show_stronger_together_plan_modal();
      } else {
        this.$router.push("/settings/account");
      }
      this.$store.commit("set_license_info", response_license_info);
    },
    form_login_submit(do_signup = false) {
      this.clear_validation_errors_cont();
      this.$v.form_login.$touch();
      if (this.$v.form_login.$anyError) {
        this.scroll_to_first_validation_error();
        return false;
      }

      this.login_btn_is_enabled = false;

      let wpcal_request = {};
      let action_auth_login = "license_auth_login";
      wpcal_request[action_auth_login] = this.form_login;
      let action_license_status = "license_status";
      wpcal_request[action_license_status] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          this.notify_single_action_result(response.data[action_auth_login], {
            success_msg: "Successfully logged in."
          });
          if (
            response.data[action_auth_login].status == "success" &&
            response.data[action_license_status].status == "success"
          ) {
            let response_license_info =
              response.data[action_license_status].license_info;
            this.on_login_success(response_license_info);
          }
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.login_btn_is_enabled = true;
        });
    },
    form_signup_and_login_submit() {
      this.clear_validation_errors_cont();
      this.$v.form_signup.$touch();
      if (this.$v.form_signup.$anyError) {
        this.scroll_to_first_validation_error();
        return false;
      }

      this.signup_btn_is_enabled = false;

      let wpcal_request = {};
      let action_signup = "license_signup_and_login";
      wpcal_request[action_signup] = this.form_signup;

      let action_license_status = "license_status";
      wpcal_request[action_license_status] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          if (response.data[action_signup]?.status === "error") {
            this.notify_single_action_result(response.data[action_signup], {
              success_msg: this.T__("Settings saved.")
            });
          }
          if (response.data[action_signup]?.status === "success") {
            if (
              response.data[action_signup]?.success === "signedup_and_added"
            ) {
              this.notify_single_action_result(response.data[action_signup], {
                success_msg: this.T__("Successfully logged in.")
              });
              let response_license_info =
                response.data[action_license_status]?.license_info;
              this.on_login_success(response_license_info);
            } else if (response.data[action_signup]?.success === "user_added") {
              //signup success but login failed
              this.on_signup_success();
            }
          }
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.signup_btn_is_enabled = true;
        });
    },
    // form_signup_submit() {
    //   this.clear_validation_errors_cont();
    //   this.$v.form_signup.$touch();
    //   if (this.$v.form_signup.$anyError) {
    //     this.scroll_to_first_validation_error();
    //     return false;
    //   }

    //   this.signup_btn_is_enabled = false;

    //   let wpcal_request = {};
    //   let action_signup = "license_signup";
    //   wpcal_request[action_signup] = this.form_signup;

    //   let post_data = {
    //     action: "wpcal_process_admin_ajax_request",
    //     wpcal_request: wpcal_request
    //   };

    //   axios
    //     .post(window.wpcal_ajax.ajax_url, post_data)
    //     .then(response => {
    //       if (
    //         response.data[action_signup].hasOwnProperty("status") &&
    //         response.data[action_signup].status === "error"
    //       ) {
    //         this.notify_single_action_result(response.data[action_signup], {
    //           success_msg: this.T__("Settings saved.")
    //         });
    //       }
    //       if (
    //         response.data[action_signup].hasOwnProperty("status") &&
    //         response.data[action_signup].status === "success"
    //       ) {
    //         this.on_signup_success();
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     })
    //     .then(() => {
    //       this.signup_btn_is_enabled = true;
    //     });
    // },
    on_signup_success() {
      this.form_login.email = this.form_signup.email;
      this.show_login_form(true);
    },
    show_stronger_together_plan_modal() {
      this.$modal.show("stronger_together_plan_modal");
    },
    handle_stronger_together_plan_modal_button() {
      this.stronger_together_plan_details.i_understand_clicked = true;
      this.$modal.hide("stronger_together_plan_modal");
      this.$router.push("/event-types");
    },
    stronger_together_plan_modal_before_close(event) {
      if (
        !this.stronger_together_plan_details.i_understand_clicked ||
        !this.stronger_together_plan_details.consent
      ) {
        event.stop();
      }
    },
    check_and_set_first_time_logged_in() {
      if (this.$store.getters.get_license_info === null) {
        //propably not data not loaded
        return;
      }
      if (this._isEmpty(this.$store.getters.get_license_info)) {
        //initial setup not done, ask admin for login
        this.first_time_logged_in = true;
        this.show_signup_form();
        return;
      }
    },
    show_login_form(form_signup_success = false) {
      this.$v.form_login.$reset();
      this.show_form = "login";
      this.form_signup_success = form_signup_success;
    },
    show_signup_form() {
      this.$v.form_signup.$reset();
      this.show_login_with_other_account_txt = false;
      this.signup_password_note_shown_once = false;
      this.show_form = "signup";
      this.form_signup_success = false;
    }
  },
  watch: {
    show_signup_password_note(is_show) {
      if (is_show) {
        this.signup_password_note_shown_once = true;
      }
    }
  },
  mounted() {
    this.check_and_set_first_time_logged_in();
    if (this.form_login.email == "") {
      this.form_login.email = this.$store.getters.get_license_info.email
        ? this.$store.getters.get_license_info.email
        : this.$store.getters.get_current_admin_details.email;
    }
    if (this.form_signup.email == "") {
      this.form_signup.email = this.$store.getters.get_license_info.email
        ? this.$store.getters.get_license_info.email
        : this.$store.getters.get_current_admin_details.email;
    }
    if (this.attempt_to_change_account) {
      this.form_login.email = "";
      this.form_signup.email = "";
      this.show_login_with_other_account_txt = true;
      this.ref_focus("form_login_email");
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.get_license_info === null) {
      //propably not data not loaded
      next();
      return;
    }
    if (this._isEmpty(this.$store.getters.get_license_info)) {
      //initial setup not done, ask admin for login
      //router.app.$router.push("/settings/account/login");
      next(false);
      return;
    }
    next();
  }
};
</script>

<style scoped>
.covid-consent-cont {
  padding: 20px;
  font-family: "Rubik";
}
.covid-consent-cont .consent-action {
  margin-top: 20px;
}
.covid-consent-cont label.consent-agreement {
  border: 1px solid #d8dbe7;
  display: block;
  padding: 5px;
  border-radius: 5px;
  padding-left: 30px;
  position: relative;
  margin: 5px 0;
}
.covid-consent-cont label:hover {
  background-color: #e4e9f5;
}
.covid-consent-cont label.consent-agreement input[type="checkbox"] {
  position: absolute;
  margin: 1px 0 0 -24px;
}
.covid-consent-cont button {
  padding: 13px;
  font-size: 16px;
  background-color: #567bf3;
  color: #fff;
  border: 0;
  border-radius: 5px;
  outline: 0;
  cursor: pointer;
  width: 300px;
}
.covid-consent-cont button:disabled {
  background-color: #c5c5c5;
  color: #d6d6d6;
  cursor: not-allowed;
}
</style>
